import { useNavigate } from 'react-router-dom';
import { logout } from '../../utils/auth';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <button
      className="btn btn-outline-danger btn-sm"
      onClick={handleLogout}
    >
      Logout
    </button>
  );
};

export default LogoutButton;
